// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"dfba75d5","453":"a058c744","796":"0db1ea97"}[chunkId] + ".chunk.js";
};